import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authMe, authLogout } from "./api";

const AuthContext = createContext({
  user: null,
  loading: true,
  refresh: async () => {},
  signOut: async () => {},
  setUser: () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const me = await authMe();
      setUser(me);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const signOut = useCallback(async () => {
    try {
      await authLogout();
    } catch {
      /* ignore network errors on logout */
    }
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, refresh, signOut, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function buildLoginUrl(returnPath = "/me/trips") {
  const redirectUrl = window.location.origin + returnPath;
  return `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
